import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

import Product from "./Product"

export default function Products() {
    const { products, loading, pageType } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading, pageType: state.pageType }))

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => {
                api.loadRecommendations({ skipPageViews: true, skipEvents: true })
            })
        }
        return () => { document.querySelectorAll('#ns-product-grid .nosto_element').forEach(el => el.remove()) };
    }, [ products.hits ])

    return (
        <ul
            class="ns-grid ns-page-width ns-list-unstyled" 
            id="ns-product-grid" 
            style={loading ? "opacity: 0.3;" : ""}
        >
            {products.hits.map((hit, index) => (
                <Product 
                    product={hit} 
                    key={hit.productId || index}
                    pageType={pageType}
                />
            ))}
        </ul>
    )
}
